import React, { useState, useEffect, useContext } from "react";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getTotalCobradoAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const money = (n) => new Intl.NumberFormat("es-NI", { style: "currency", currency: "NIO" }).format(n);

const RecuperacionDiaria = ({ selectedSucursal }) => {
  const [totalCobrado, setTotalCobrado] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getTotalCobradoAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setTotalCobrado(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/clients`)}
      icon={<PaymentsRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="success.light"
      iconColor="success.main"
      value={money(totalCobrado)}
      label="Recuperación diaria"
    />
  );
};

export default RecuperacionDiaria;
